import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "fp_cookie_consent";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const open = () => setShow(true);
    window.addEventListener("fp:open-cookies", open);
    let t;
    if (!localStorage.getItem(KEY)) t = setTimeout(open, 800);
    return () => { clearTimeout(t); window.removeEventListener("fp:open-cookies", open); };
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[60] max-w-sm w-[calc(100%-2rem)] sm:w-96 bg-white border border-border rounded-lg shadow-2xl p-5 animate-in slide-in-from-bottom-4 fade-in duration-500" data-testid="cookie-consent">
      <div className="flex items-start gap-3 mb-3">
        <div className="shrink-0 h-9 w-9 rounded-full bg-brand/10 flex items-center justify-center">
          <Cookie className="h-5 w-5 text-brand" />
        </div>
        <div>
          <p className="font-heading font-semibold text-sm">Uso de cookies</p>
          <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
            Usamos cookies propias y de terceros para el funcionamiento del sitio y analizar su uso. Puede aceptarlas todas o rechazar las no esenciales. Más información en nuestra{" "}
            <Link to="/pagina/politica-cookies" className="text-brand underline">Política de cookies</Link>.
          </p>
        </div>
      </div>
      <div className="flex gap-2 justify-end">
        <button onClick={() => decide("rejected")} className="text-xs px-3 py-2 rounded-sm border border-border hover:border-brand transition-colors" data-testid="cookie-reject">Rechazar</button>
        <button onClick={() => decide("accepted")} className="text-xs px-4 py-2 rounded-sm bg-brand text-white font-semibold hover:bg-brand-dark transition-colors" data-testid="cookie-accept">Aceptar todas</button>
      </div>
    </div>
  );
};
